<app-dialog 
    [title]="dialogData ? 'Edit Location' : 'Add New Location'" 
    [actions]="[
		{ text: 'Cancel', buttonStyle: 'underline' },
		{ text: dialogData ? 'Update' : 'Save', isDisabled: !whLocationForm.valid, spin: loading }
	]" 
    (close)="dialogRef.close()" 
    (action)="action($event)"
>
    <div class="warehouse" [formGroup]="whLocationForm">

        <div class="input-container mt-3">         
            <label for="" class="input-container_label">Warehouse</label>
            <mat-form-field appearance="fill" class="custom-mat-select">
                <mat-select   class="input-container_input input-container_input--select" formControlName="warehouseId" [attr.disabled]="isDisableWarehouse">
                    <mat-option *ngFor="let wh of whs" [value]="wh.warehouseId">
                        {{ wh.name }} <small class="whAddress-text">({{wh.city}}, {{wh.state}})</small></mat-option>
                </mat-select>
            </mat-form-field>
            
        </div>
        <div class="input-container mt-3">
            <label for="" class="input-container_label">Location Code</label>
            <input type="text" (focusout)="valueChange($event)"  class="input-container_input" formControlName="locationCode" placeholder="example: 5-L-N-6" />
        </div>
        <div class="form-input-info">
            <svg xmlns="http://www.w3.org/2000/svg" width="8.461" height="8.461" viewBox="0 0 8.461 8.461">
                <path id="Icon_awesome-question-circle" data-name="Icon awesome-question-circle"
                    d="M9.024,4.793A4.231,4.231,0,1,1,4.793.563,4.23,4.23,0,0,1,9.024,4.793ZM4.907,1.961A2.21,2.21,0,0,0,2.918,3.049a.2.2,0,0,0,.046.277l.592.449a.2.2,0,0,0,.284-.036c.3-.387.514-.611.978-.611.349,0,.78.224.78.562,0,.255-.211.387-.555.58-.4.225-.932.5-.932,1.205v.068a.2.2,0,0,0,.2.2h.955a.2.2,0,0,0,.2-.2V5.521c0-.486,1.419-.506,1.419-1.82A1.946,1.946,0,0,0,4.907,1.961ZM4.793,6.192a.785.785,0,1,0,.785.785A.786.786,0,0,0,4.793,6.192Z"
                    transform="translate(-0.563 -0.563)" fill="#7b7b7b" />
            </svg>
            <span>Recommended format is aisle [number]-side[R/L]-shelf[letter]-bin[number] example : 5-L-N-4</span>
        </div> 
        <app-page-container-devider [title]="''" [small]="true" [class]="'devider'" class="pt-2"></app-page-container-devider>
        <div class="row row-sm">
            <div class="col-6">
                <div class="input-container mt-3">
                    <label for="" class="input-container_label">Aside</label>
                    <input type="number"(input)="onDigitInput($event)" (focusout)="changeValue($event,'aside')" maxlength="1" class="input-container_input" formControlName="aside"  />
                </div>
            </div>
            <div class="col-6">
                <div class="input-container mt-3">
                    <label for="" class="input-container_label">Side</label>
                    <input type="text"  (input)="onLetterInput($event)"  (focusout)="changeValue($event,'side')" pattern="^[A-Z]$" 
                    maxlength="1" class="input-container_input" formControlName="side" />
                </div>
            </div>
            <div class="col-6">
                <div class="input-container mt-3">
                    <label for="" class="input-container_label">Shelf</label>
                    <input type="text" (input)="onLetterInput($event)"  (focusout)="changeValue($event,'shelf')"  pattern="[A-Z]*"  maxlength="1"  class="input-container_input" formControlName="shelf" />
                </div>
            </div>
            <div class="col-6">
                <div class="input-container mt-3">
                    <label for="" class="input-container_label">Bin</label>
                    <input type="number" (input)="onDigitInput($event)" (focusout)="changeValue($event,'bin')"  maxlength="1" class="input-container_input" formControlName="bin"  />
                </div>
            </div>
        </div>
        
    </div>
</app-dialog>